import { useState, useCallback } from "react";
import { message } from "antd";
import apiClient from "utils/apiClient";

export function useAdminWebsites() {
  const [sites, setSites] = useState([]);
  const [totalElements, setTotalElements] = useState(0);
  const [loading, setLoading] = useState(false);

  const fetchSites = useCallback(
    async ({ query = "", staleOnly = false, page = 0, size = 20 } = {}) => {
      setLoading(true);
      try {
        const res = await apiClient.get(
          `/ovizia-service/api/v1/admin/websites`,
          { params: { query, staleOnly, page, size } },
        );

        setSites(res.data.content ?? []);
        setTotalElements(res.data.totalElements ?? 0);
      } catch (err) {
        message.error("Failed to load websites");
      } finally {
        setLoading(false);
      }
    },
    [],
  );

  const fetchSiteById = useCallback(async (id) => {
    try {
      const { data } = await apiClient.get(
        `/ovizia-service/api/v1/admin/websites/${id}`,
      );
      return data;
    } catch (err) {
      message.error("Website not found");
      return null;
    }
  }, []);

  return { sites, totalElements, loading, fetchSites, fetchSiteById };
}
